//@flow
import { commitMutation, graphql } from 'react-relay';
import type { PayloadError } from 'react-relay';

const mutation = graphql`
    mutation profileWeblinksMutation($input: FirmDesignProfileWeblinksMutationInput!) {
        firmDesignProfileWeblinksMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    webLinks {
                        website
                        facebook
                        instagram
                        pinterest
                    }
                }
            }
        }
    }
`;

type ProfileWeblinksMutationArgs = {
    firmId: string,
    facebook: ?string,
    pinterest: ?string,
    instagram: ?string,
    website: ?string,
};

export const profileWeblinksMutation = (
    environment: Object,
    args: ProfileWeblinksMutationArgs
): Promise<void> => {
    const { firmId, facebook, instagram, website, pinterest } = args;
    const input = {
        serviceId: firmId,
        facebook,
        instagram,
        website,
        pinterest,
    };

    return new Promise((resolve, reject) => {
        const onCompleted = (response, errors: ?Array<PayloadError>) => {
            if (errors && errors.length) {
                reject(errors);
            }
            resolve(response);
        };

        const onError = (error: Error) => {
            reject([error]);
        };

        try {
            commitMutation(environment, {
                mutation,
                variables: { input },
                onCompleted,
                onError,
            });
        } catch (error) {
            reject([error]);
        }
    });
};
